import { CosmeticType } from 'src/utils/types';
import icCosmeticAvatar from 'assets/svg/ic_cm_avatar.svg';
import icCosmeticEmote from 'assets/svg/ic_cm_emote.svg';
import icCosmeticSpaceship from 'assets/svg/ic_cm_spaceship.svg';
import icCosmeticAvatarFrame from 'assets/svg/ic_cm_avatar_frame.svg';
export const parseCosmeticTypeIcon = type => {
  if (!type) {
    return '';
  }

  switch (type) {
    case CosmeticType.AVATAR:
      {
        return icCosmeticAvatar;
      }

    case CosmeticType.AVATAR_FRAME:
      {
        return icCosmeticAvatarFrame;
      }

    case CosmeticType.EMOTE:
      {
        return icCosmeticEmote;
      }

    case CosmeticType.SPACESHIP:
      {
        return icCosmeticSpaceship;
      }

    default:
      {
        return '';
      }
  }
};